import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { SearchTechSupportModel } from 'src/app/admin-panel/models/system-profiles/search-tech-support.model';
import { TechSupportModel } from 'src/app/admin-panel/models/system-profiles/tech-support.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';
import { AddOrEditTechSupportComponent } from './add-or-edit-tech-support/add-or-edit-tech-support.component';
import { DeleteTechSupportComponent } from './delete-tech-support/delete-tech-support.component';

@Component({
  selector: 'app-tech-support',
  templateUrl: './tech-support.component.html',
  styleUrls: ['./tech-support.component.scss']
})
export class TechSupportComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  public techSupportList : Array<TechSupportModel>;
  public searchTechSupportModel: SearchTechSupportModel = new SearchTechSupportModel();
  public totalPages: number;
  public totalRecords: number;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public administratorService: AdministratorService,
    private messageService: MessageService
  ) { 
    this.techSupportList = new Array<TechSupportModel>();   
  }

  ngOnInit(): void {
    this.getAllTechSupport(this.searchTechSupportModel)
  }
  //#endregion
  //#region Public Methods
  getAllTechSupport(searchModel: SearchTechSupportModel) {  
    this.administratorService.getAllTechSupport(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchTechSupportModel.pageNumber > 1) {
            this.techSupportList = this.techSupportList.concat(response.data)
          }
          else {
            this.techSupportList = response.data;
          }
        },
        error: errorResponse => {

        }
      });

  };
  loadMoreTechSupport(){
    this.searchTechSupportModel.pageNumber = this.searchTechSupportModel.pageNumber + 1;
    this.getAllTechSupport(this.searchTechSupportModel);
  }
  addNewTechSupport(){
    const ref = this.dialogService.open(AddOrEditTechSupportComponent, {
      header: 'Add New Tech Support',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchTechSupportModel.pageNumber = 1;
        this.getAllTechSupport(this.searchTechSupportModel)
        this.messageService.add({severity:'success', summary:'User was succesful added!',life:3000});
      }
    });
  }
  editTechSupport(userId:string){
    const ref = this.dialogService.open(AddOrEditTechSupportComponent, {
      data: {
        id: userId
      },
      header: 'Edit Tech Support',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchTechSupportModel.pageNumber = 1;
        this.getAllTechSupport(this.searchTechSupportModel)
        this.messageService.add({severity:'success', summary:'User was succesful updated!',life:3000});
      }
    });
  }
  deleteTechSupport(userId:string){
    const ref = this.dialogService.open(DeleteTechSupportComponent, {
      data: {
        id: userId
      },
      header: 'Delete Tech Support',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchTechSupportModel.pageNumber = 1;
        this.getAllTechSupport(this.searchTechSupportModel)
        this.messageService.add({severity:'success', summary:'User was succesful deleted!',life:3000});
      }
    });
  }

  searhTechSupport(searchModel: SearchTechSupportModel) {
    searchModel.pageNumber = 1;
    this.getAllTechSupport(searchModel)
  }
  clearSearch() {
    this.searchTechSupportModel = new SearchTechSupportModel();
    this.getAllTechSupport(this.searchTechSupportModel);
  }
  //#endregion
  //#Private Methods
  //#endregion
}
